import { axiosPlacement } from './AxiosInstance';

const STUDENT_API_URL = '/students';

const ATTENDANCE_API_URL = '/attendances';
const OLDRECEIPT_API_URL = '/oldstudentreceipts';

// Student CRUD Operations
export const getStudents = async (limit = 10, page = 1, search = '', filters = {}) => {
  try {
    let url = `${STUDENT_API_URL}/full-data-list?limit=${limit}&page=${page}&search=${search}`;
    
    // Add additional filters to the URL
    Object.keys(filters).forEach(key => {
      if (filters[key] !== undefined && filters[key] !== null && filters[key] !== '') {
        url += `&${key}=${encodeURIComponent(filters[key])}`;
      }
    });

    const response = await axiosPlacement.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching students', error);
    throw error;
  }
};

// *** NEW - Get applicable students with filters and pagination ***
export const getApplicableStudents = async (payload) => {
  try {
    const response = await axiosPlacement.post(`${STUDENT_API_URL}/applicable-students`, payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching applicable students', error);
    throw error;
  }
};

// *** NEW - Get ending batches with pagination ***
export const getEndingBatches = async (page = 1, limit = 20, search = '') => {
  try {
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const response = await axiosPlacement.get(
      `/batches/ending-batches?page=${page}&limit=${limit}${searchParam}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching ending batches', error);
    throw error;
  }
};

export const getStudentsFromOldReceipts = async (limit = 10, page = 1, filters = {}) => {
  try {
    let url = `${OLDRECEIPT_API_URL}?limit=${limit}&page=${page}`;
    
    if (filters.name) url += `&studentName=${encodeURIComponent(filters.name)}`;
    if (filters.email) url += `&studentEmail=${encodeURIComponent(filters.email)}`;
    if (filters.phone) url += `&studentNumber=${encodeURIComponent(filters.phone)}`;
    if (filters.courseName) url += `&courseName=${encodeURIComponent(filters.courseName)}`;
    if (filters.batchName) url += `&departmentName=${encodeURIComponent(filters.batchName)}`;
    
    const response = await axiosPlacement.get(url);
    return {
      data: response.data?.data || [],
      pagination: response.data?.pagination || {},
    };
  } catch (error) {
    console.error('Error fetching students from old receipts', error);
    throw error;
  }
};

// *** NEW - Get tab-wise student info ***
export const getStudentTabWiseInfo = async (payload) => {
  try {
    const response = await axiosPlacement.post(`${STUDENT_API_URL}/tab-wise-info`, payload);
    return response.data;
  } catch (error) {
    console.error('Error fetching student tab-wise info', error);
    throw error;
  }
};

export const createStudent = async (studentData) => {
  try {
    const response = await axiosPlacement.post(STUDENT_API_URL, studentData);
    return response.data;
  } catch (error) {
    console.error('Error creating student', {
      error: error.response?.data,
      requestData: studentData,
    });
    throw error;
  }
};

export const updateStudent = async (studentId, studentData) => {
  try {
    const response = await axiosPlacement.put(`${STUDENT_API_URL}/${studentId}`, studentData);
    return response.data;
  } catch (error) {
    console.error('Error updating student', error);
    throw error;
  }
};

export const deleteStudent = async (studentId) => {
  try {
    const response = await axiosPlacement.delete(`${STUDENT_API_URL}/${studentId}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting student', error);
    throw error;
  }
};

export const getStudentById = async (studentId) => {
  try {
    const response = await axiosPlacement.get(`${STUDENT_API_URL}/${studentId}`);
    return {
      data: response.data?.data,
      status: response.status,
      message: response.data?.message,
    };
  } catch (error) {
    console.error('Error fetching student details', error);
    throw error;
  }
};

// Student Profile Operations
export const getStudentProfileById = async (studentId) => {
  try {
    const response = await axiosPlacement.get(`${STUDENT_API_URL}/${studentId}`);
    return {
      data: response.data?.data,
      status: response.status,
      message: response.data?.message,
    };
  } catch (error) {
    console.error('Error fetching student profile', error);
    throw error;
  }
};

export const updateStudentProfile = async (studentId, profileData) => {
  try {
    const response = await axiosPlacement.put(`${STUDENT_API_URL}/${studentId}`, profileData);
    return response.data;
  } catch (error) {
    console.error('Error updating student profile', error);
    throw error;
  }
};

// Attendance Operations
export const getStudentAttendancePercentage = async (studentId, batchId) => {
  try {
    const response = await axiosPlacement.get(
      `${ATTENDANCE_API_URL}/attendance-percentage?studentId=${studentId}&batchId=${batchId}`
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching attendance percentage', error);
    throw error;
  }
};

// Combined operations that might need both student and profile data
export const getCompleteStudentDetails = async (studentId) => {
  try {
    const [studentResponse, profileResponse] = await Promise.all([
      axiosPlacement.get(`${STUDENT_API_URL}/${studentId}`),
      axiosPlacement.get(`${STUDENT_API_URL}/${studentId}`),
    ]);

    return {
      student: studentResponse.data?.data,
      profile: profileResponse.data?.data,
    };
  } catch (error) {
    console.error('Error fetching complete student details', error);
    throw error;
  }
};

// Optional: Function to dynamically change the API instance at runtime
export const setApiInstance = (newInstance) => {
  // Not used anymore in the new architecture
};
